// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { boxStyles } from "@store/Themes/common/mixins/box";
import React, { FC } from "react";
import { css } from "styled-components";

export interface AccentBoxStyles {
    wrapper?: InjectableCss;
}

const accentBoxStyles: AccentBoxStyles = {
    wrapper: {
        css: css`
            ${boxStyles()}
        `,
    },
};

const styles = accentBoxStyles;

const AccentBox: FC<WidgetProps> = props => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Zone zoneName="Content00" contentId={props.id} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: AccentBox,
    definition: {
        group: "Basic",
        displayName: "Accent Box",
    },
};

export default widgetModule;
